// extracted by mini-css-extract-plugin
export default {"AddProduct":"AddProduct_AddProduct__mIWZq","wrapper":"AddProduct_wrapper__ES5AR","formContainer":"AddProduct_formContainer__SBdNW","basic":"AddProduct_basic__NnciH"};